import {FILTER_TYPE, GLOBAL_FILTER_FIELD} from '../../../constants';
import {
	convertToGlobalFilter,
	getUnifiedFilterOperator,
	isOperator,
} from '../../../forecast-app/shared/components/filters/filter_logic';

export const getTimeApprovalSearchQuery = appliedFilters => {
	const filters = [];
	if (!appliedFilters?.timeRegs) {
		return {filters};
	}

	const timeRegFilters = appliedFilters.timeRegs;
	for (const key of Object.keys(timeRegFilters)) {
		if (isOperator(key)) {
			continue;
		}

		const value = timeRegFilters[key];
		const unifiedFilterOperator = getUnifiedFilterOperator(key, timeRegFilters);

		const filterMappings = [
			[FILTER_TYPE.TEAM_MEMBER, GLOBAL_FILTER_FIELD.TEAM_MEMBER],
			[FILTER_TYPE.PROJECT, GLOBAL_FILTER_FIELD.PROJECT_TIME_REG],
			[FILTER_TYPE.ROLE, GLOBAL_FILTER_FIELD.ROLE_TIME_REG],
			[FILTER_TYPE.TEAM, GLOBAL_FILTER_FIELD.TEAM_TIME_REG],
			[FILTER_TYPE.DEPARTMENT, GLOBAL_FILTER_FIELD.DEPARTMENT_TIME_REG],
			[FILTER_TYPE.CLIENT, GLOBAL_FILTER_FIELD.CLIENT_TIME_REG],
			[FILTER_TYPE.INTERNAL_TIME, GLOBAL_FILTER_FIELD.INTERNAL_TIME_REG],
			[FILTER_TYPE.PROJECT_OWNER, GLOBAL_FILTER_FIELD.OWNER],
		];

		const mapping = filterMappings.find(([filterKey]) => filterKey === key);
		if (mapping) {
			const [, field] = mapping;
			filters.push({
				field,
				operator: unifiedFilterOperator,
				value,
			});
		} else if (key === FILTER_TYPE.PROJECT_TYPE) {
			filters.push(convertToGlobalFilter(key, value, timeRegFilters));
		}
	}

	return {filters};
};
